import { render, staticRenderFns } from "./remiderModal.vue?vue&type=template&id=ebd2faf4&"
import script from "./remiderModal.vue?vue&type=script&lang=js&"
export * from "./remiderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports